import axiosBaseApi from '../common/lib/axiosBaseApi';
import { ActiveLeaderboard } from '@repo/common-types';

export const getLeaderboard = async () => {
  try {
    return (await axiosBaseApi.get<ActiveLeaderboard>(`/v1/leaderboard/`)).data;
  } catch (error) {
    console.error('Error fetching leaderboard -- getLeaderboard', error);
    return null;
  }
};
